import React, { useState } from 'react';

const ImageWithFallback: React.FC<{ src: string, alt: string, fallbackContent: React.ReactNode }> = ({ src, alt, fallbackContent }) => {

  const [hasError, setHasError] = useState<boolean>(false);

  const handleError = () => {
    setHasError(true); // Set error state when image fails to load
  };

  React.useEffect(() => {
    setHasError(false)
  }, [src])

  return (
    <div className="relative w-full h-full">
      <img
        loading='lazy'
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${hasError ? 'hidden' : ''}`}
        onError={handleError}
      />
      {hasError && (
        <div className="absolute inset-0 flex items-center justify-center text-red-600 font-bold text-xl">
          {fallbackContent}
        </div>
      )}
    </div>
  );
};

export default ImageWithFallback;
